import type { Member } from '../../../types';
import type { ClusterState, InvitablePerson } from './types';

/**
 * People tagged (via face auto-match) somewhere in this import batch who don't
 * have an account yet (`status: 'no_email'`) — worth nudging to invite, since
 * they're exactly the untagged relatives this feature exists to surface.
 * Pets and anyone already invited/active are excluded.
 */
export function computeInvitablePeople(
  clusters: ClusterState[],
  members: Member[],
  eventChips: { id: string; title: string }[]
): InvitablePerson[] {
  const invitableMap = new Map<string, InvitablePerson>();

  clusters.forEach((c, i) => {
    const eventTitle = eventChips[i]?.title ?? c.title;
    for (const faces of Object.values(c.facesByPhoto)) {
      for (const f of faces) {
        if (!f.assignedUserId) continue;
        const member = members.find(m => m.user.id === f.assignedUserId);
        if (!member || member.petType || member.status !== 'no_email') continue;
        const entry = invitableMap.get(member.id) ?? { memberId: member.id, userId: member.user.id, name: member.user.name, eventTitles: [] };
        if (!entry.eventTitles.includes(eventTitle)) entry.eventTitles.push(eventTitle);
        invitableMap.set(member.id, entry);
      }
    }
  });

  return Array.from(invitableMap.values());
}
